import { GeneralsMealPreferencesAvoid } from "@/clients/models/GeneralsMealPreferencesAvoid";
import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateFoodAvoids = () => {
  const { mutate, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.FOOD_AVOIDS],
    mutationFn: async ({ foodToSkip }: GeneralsMealPreferencesAvoid) => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealPreferencesService.updateGeneralMealPreferencesAvoidsApiV1MealPreferencesGeneralAvoidsPut(
          user.id,
          { foodToSkip },
        );
      return data;
    },
  });

  return {
    updateFoodAvoids: mutate,
    isUpdating: isPending,
    isError,
    error,
  };
};
